module.exports = __webpack_public_path__ + "img/铂诗钥.2fdff3b.png";